<template>
  <div>
    <!-- EACH PRODUCT -->
    <div v-for="(e, index) in equipment" :key="index" class="product-row mb-4">
      <div class="product-image">
        <img :src="e.image" alt width="52" />
      </div>

      <div class="product-info">
        <div class="text-bold mb-1">{{ e.name }}</div>
        <!-- update descriptions -->
        <div
          class="mb-3"
        >Detects when a window is opened. Most accessible windows should be protected.</div>
        <a href>Learn more about {{ e.name }}</a>
      </div>

      <div class="pricing">
        <div class="subtotal text-bold">${{ e.subtotal }}</div>
        <div class="price">${{ e.price }} each</div>
      </div>
      <div class="product-quantity">
        <NumberInput
          controls
          :value="e.quantity"
          @change="(value) => updateQuantity(index, value, e.lead_key)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import NumberInput from "./NumberInput.vue";
import formatCurrency from "../Libraries/formatCurrency";

export default {
  props: {
    equipment: {
      type: Array,
      required: true
    }
  },

  components: {
    NumberInput
  },

  methods: {
    ...mapActions(["setInterestedEquipmentQty"]),

    /**
     * Update the equipment quantity
     *
     * @param {number} index
     * @param {number} value
     * @param {string} leadKey
     *
     * @returns null
     */
    updateQuantity(index, value, leadKey) {
      let equipment = [...this.equipment];
      let equipmentItem = equipment[index];
      equipmentItem.quantity = value;
      this.setInterestedEquipmentQty({
        key: leadKey,
        qty: value
      });
      equipmentItem.subtotal = this.calculateSubtotal(equipmentItem);
      this.$emit('change', equipment);
    },

    calculateSubtotal(equipment) {
      let quantity = equipment.quantity;
      let price = equipment.price;
      let total = quantity * price;
      let formatted = formatCurrency(total).replace(".00", "");

      return formatted;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-row {
  display: flex;
  padding-bottom: 4rem;
  border-bottom: 1px solid #b5b5b5;
  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }

  @media (max-width: 480px) {
    display: block;
    text-align: center;
  }
}

.product-image {
  margin-right: 1.5rem;
}

.product-quantity {
  max-width: 150px;
  display: flex;
  align-items: center;
}

.product-info {
  max-width: 300px;
  @media (max-width: 768px) {
    max-width: 240px;
  }
  @media (max-width: 480px) {
    max-width: 100%;
  }
}

.pricing {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  color: #989898;
  .subtotal {
    margin-right: 1rem;
    font-size: 1.25em;
  }
}
</style>

<style lang="css">
.number-input__input {
  text-align: center;
}
</style>
